import axios from "axios";

const apiViacep = axios.create({
    baseURL: "https://viacep.com.br/ws",
});

export function consultaCep(cep: string){
    return apiViacep.get(`/${cep}/json`);
}

export default apiViacep;